import { Box, Button, Container, Typography } from '@mui/material';

export const WelcomeSplash = () => {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          textAlign: 'center',
          gap: 2,
        }}
      >
        <Box
          component="img"
          src="https://waev-auth0-assets.s3.amazonaws.com/WaevIcon-FullColor.png"
          alt="Waev"
          sx={{ height: 96, width: 'auto' }}
        />
        <Typography variant="h4" component="h1">
          Password set!
        </Typography>
        <Typography color="text.secondary">You can now sign in to the Waev brand dashboard.</Typography>
        <Button variant="contained" href="/">
          Sign In
        </Button>
      </Box>
    </Container>
  );
};
